<template>
    <div class="quiz-view-wrapper">
        <component :is="currentSystem" v-if="!loading" />
    </div>
</template>

<script>
import { mapActions } from 'vuex';

import SingleSystemQuizView from './SingleSystemQuizView';
import RhymeSystemQuizView from './RhymeSystemQuizView';
import AlphabetSystemQuizView from './AlphabetSystemQuizView';
import DoubleSystemQuizView from './DoubleSystemQuizView';
import OlpaSystemQuizView from './OlpaSystemQuizView/';
import NameSystemQuizView from './NameSystemQuizView';

export default {
    data() {
        return {
            systems: [
                {
                    id: 'singlesys',
                    component: SingleSystemQuizView
                },
                {
                    id: 'rhymesys',
                    component: RhymeSystemQuizView
                },
                {
                    id: 'alphabetsys',
                    component: AlphabetSystemQuizView
                },
                {
                    id: 'doublesys',
                    component: DoubleSystemQuizView
                },
                {
                    id: 'olpasys',
                    component: OlpaSystemQuizView
                },
                {
                    id: 'namesys',
                    component: NameSystemQuizView
                }
            ],
            loading: true
        };
    },

    computed: {
        currentSystem() {
            return this.systems.find(system => system.id === this.$route.params.systemId).component;
        }
    },

    async mounted() {
        await this.loadSystems();
        this.loading = false;
    },

    methods: {
        ...mapActions({ loadSystems: 'moduleCourse/loadSystems' })
    }
};
</script>

<style lang="scss" scoped>
.quiz-view-wrapper {
    background-image: url('~@/assets/images/background.png');
    display: flex;
    justify-content: center;
    align-items: center;
    color: white;
}
</style>
